import Axios from 'axios'
import moment from 'moment'

export default {
    state: {
        planning: [],
        trainees: []
    },
    getters: {
        planning(state) {
            return state.planning
        },
        getTrainees(state) {
            return state.trainees
        }
    },
    mutations: {
        setPlanning(state, payload) {
            state.planning = payload
        },
        setTrainees(state, payload) {
            state.trainees = payload
        }
    },
    actions: {
        // new
        getSessions: async ({ commit, getters }) => {
            commit('setLoading')

            await Axios.get(`${process.env.VUE_APP_API_URL_SESSIONS}${getters.user.type}/${getters.user._id}`)
                .then(res => {
                    if (res.data.success) {
                        commit('setPlanning', res.data.data)
                        commit('setLoading')
                    }
                })
                .catch(error => {
                    commit('setLoading')
                })
        },
        // new
        createSession: async ({ commit, dispatch }, payload) => {
            payload.date = moment(moment(moment(payload.date).format('L') + ' ' + payload.time).format()).local(true);

            await Axios.post(`${process.env.VUE_APP_API_BASE_URL}api/sessions`, payload).then(async res => {
                if (res.data.success) {
                    commit('setSnackAlert', {
                        status: true,
                        success: true,
                        error: false,
                        message: 'Session créer avec succés.'
                    });
                    await dispatch('getSessions');
                } else throw new Error(res.data);
            }).catch(error => {
                commit('clearError')
                commit('setError', error)
                commit('setSnackAlert', {
                    status: true,
                    success: false,
                    error: true,
                    message: 'Erreur de connexion avec le serveur. réssayer plus tard.'
                });
            })
        },
        // old
        getPlanning: async ({ commit, getters }) => {
            commit('setLoading')

            await Axios.get(`${process.env.VUE_APP_API_URL_LIVE_PLANNING}${getters.user.type}/${getters.user._id}`)
                .then(res => {
                    if (res.data.success) {
                        let planning = [];
                        res.data.data.map(item => {
                            if (getters.user.type == 'coach')
                                item.sessions.map(session => planning.push({ user: item.user, ...session }))
                            else if (getters.user.type == 'user')
                                planning.push(item)
                        })
                        // Sort planning
                        planning.sort((a, b) => {
                            var keyA = new Date(a.date),
                                keyB = new Date(b.date);
                            // Compare the 2 dates
                            if (keyA < keyB) return -1;
                            if (keyA > keyB) return 1;
                            return 0;
                        });

                        commit('setPlanning', planning)
                        const trainees = [...new Set(res.data.data.map(item => { return item.user }))];
                        commit('setTrainees', trainees)
                        commit('setLoading')
                    } else
                        throw new Error(res.data);
                }
                ).catch(error => {
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                })
        },
        // old
        async onCreateNewEvent({ commit, dispatch }, payload) {

            payload.date = moment(moment(moment(payload.date).format('L') + ' ' + payload.time).format()).local(true);
            const url =
                `${process.env.VUE_APP_API_URL_LIVE_PLANNING}${payload.user}`

            await Axios.put(url, payload)
                .then(async res => {
                    if (res.data.success) {
                        commit('setSnackAlert', {
                            status: true,
                            success: true,
                            error: false,
                            message: 'Message envoyé.'
                        });
                        await dispatch('getPlanning');
                    } else throw new Error(res.data);
                }
                ).catch(error => {
                    commit('clearError')
                    commit('setError', error)
                    commit('setSnackAlert', {
                        status: true,
                        success: false,
                        error: true,
                        message: 'Erreur de connexion avec le serveur. réssayer plus tard.'
                    });
                })
        },
        // new
        async onUpdateSession({ commit }, payload) {
            console.log(payload)
            if (payload.date)
                payload.date = moment(moment(moment(payload.date).format('L') + ' ' + payload.time).format()).local(true);
            if (payload.startedAt)
                payload.startedAt = moment(moment(payload.startedAt)).local(true);
            if (payload.stoppedAt)
                payload.stoppedAt = moment(moment(payload.stoppedAt)).local(true);
            if (payload.reconnectedAt)
                payload.stoppedAt = moment(moment(payload.stoppedAt)).local(true);
            return await Axios.put(`${process.env.VUE_APP_API_BASE_URL}api/sessions/${payload.id}`, payload)
                .then(async res => {
                    if (res.data.success) {
                        return res.data.data
                    } else throw new Error(res.data);
                }
                ).catch(error => {
                    commit('clearError')
                    commit('setError', error)
                    commit('setSnackAlert', {
                        status: true,
                        success: false,
                        error: true,
                        message: 'Erreur de connexion avec le serveur. réssayer plus tard.'
                    });
                })
        },
        // new
        async deleteSession({ commit, dispatch }, payload) {
            commit('setLoading')
            const url =
                `${process.env.VUE_APP_API_BASE_URL}api/sessions/${payload}`

            await Axios.delete(url, payload)
                .then(async res => {
                    if (res.data.success) {
                        commit('setLoading')
                        await dispatch('getSessions');
                    } else throw new Error(res.data.message);
                }
                ).catch(error => {
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                    commit('setSnackAlert', {
                        status: true,
                        success: false,
                        error: true,
                        message: 'Erreur de connexion avec le serveur. réssayer plus tard.'
                    });
                })
        },
        async sendFeedback({ commit }, payload) {
            commit('setLoading')

            await Axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/sessions/feedback/${payload.id}`, payload)
                .then(async res => {
                    if (res.data.success) {
                        commit('setLoading')
                    } else throw new Error(res.data.message);
                }
                ).catch(error => {
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                    commit('setSnackAlert', {
                        status: true,
                        success: false,
                        error: true,
                        message: 'Erreur de connexion avec le serveur. réssayer plus tard.'
                    });
                })
        }
    }
}
